import { render, staticRenderFns } from "./inventory-details.vue?vue&type=template&id=1cf72cb5&scoped=true&"
import script from "./inventory-details.vue?vue&type=script&lang=js&"
export * from "./inventory-details.vue?vue&type=script&lang=js&"
import style0 from "./inventory-details.vue?vue&type=style&index=0&id=1cf72cb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf72cb5",
  null
  
)

export default component.exports